<template>
  <b-card
    no-body
    class="detail-area-page p-2 p-md-3 bg-white"
  >
    <!-- Header Title & Back Button -->
    <div class="d-flex align-items-center pb-2 mb-2 border-bottom-subtle">
      <button
        type="button"
        class="btn-back mr-2"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="20"
        />
      </button>
      <h3 class="page-title m-0">
        Detail Data Acuan
      </h3>
    </div>

    <!-- Search Input (Komship only) -->
    <div
      v-if="$route.query.product === 'komship'"
      class="search-bar-wrapper mb-2"
    >
      <b-input-group class="custom-search-input">
        <template #prepend>
          <b-input-group-text class="bg-transparent border-0 pr-0 pl-2 d-flex align-items-center">
            <feather-icon
              icon="SearchIcon"
              size="16"
              class="text-muted"
            />
          </b-input-group-text>
        </template>
        <b-form-input
          v-model="search"
          placeholder="Cari nama Kecamatan / Kota disini"
          class="border-0 shadow-none font-small-3"
          @input="searchArea"
        />
      </b-input-group>
    </div>

    <!-- Info Legend Banner -->
    <div class="info-legend-banner d-flex align-items-center mb-2">
      <feather-icon
        icon="InfoIcon"
        size="18"
        class="text-info mr-2 flex-shrink-0"
      />
      <div
        class="d-flex align-items-center flex-wrap"
        style="gap: 12px;"
      >
        <span class="text-dark font-small-3">Area dengan checklist</span>
        <b-form-checkbox
          :checked="true"
          class="custom-legend-checkbox"
          style="pointer-events: none;"
        >
          <span class="font-weight-bold text-dark font-small-3">tercover,</span>
        </b-form-checkbox>
        <span class="text-dark font-small-3">sementara</span>
        <b-form-checkbox
          :checked="false"
          class="custom-legend-checkbox"
          style="pointer-events: none;"
        >
          <span class="font-weight-bold text-dark font-small-3">tidak tercover</span>
        </b-form-checkbox>
      </div>
    </div>

    <!-- Table Container Card -->
    <div class="table-container-card">
      <b-overlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class="w-100"
        rounded="sm"
      >
        <div class="table-responsive m-0">
          <table class="table custom-detail-table m-0">
            <thead>
              <tr>
                <th
                  rowspan="2"
                  class="sticky-header sticky-col district-header"
                >
                  Nama Kecamatan
                </th>
                <th
                  v-for="(item, idx) in expeditions"
                  :key="`exp-${idx}`"
                  colspan="2"
                  class="sticky-header text-center expedition-header"
                >
                  {{ item }}
                </th>
              </tr>
              <tr>
                <th
                  v-for="col in expeditionColumns"
                  :key="col.key"
                  class="sticky-header-sub text-center type-header"
                >
                  {{ col.label }}
                </th>
              </tr>
            </thead>
            <tbody v-if="listSubdistrict.length > 0">
              <tr
                v-for="(item, idx) in listSubdistrict"
                :key="`data-${idx}`"
              >
                <td class="sticky-col district-cell font-medium">
                  {{ item.district_name }}
                </td>
                <td
                  v-for="col in expeditionColumns"
                  :key="`${idx}-${col.key}`"
                  class="text-center checkbox-cell"
                >
                  <b-form-checkbox
                    :checked="getCoverageArea(item, col.expedition, col.type)"
                    class="custom-table-checkbox"
                    style="pointer-events: none;"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td
                  :colspan="1 + (expeditions.length * 2)"
                  class="text-center py-4 text-muted font-small-3"
                >
                  Tidak ada data yang ditampilkan.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      search: '',
      listSubdistrictDefault: [],
      listSubdistrict: [],
      loadingData: true,
      expeditions: [],
    }
  },
  computed: {
    expeditionColumns() {
      const cols = []
      this.expeditions.forEach((expedition, idx) => {
        cols.push({
          expedition,
          type: 'non cod',
          label: 'Non COD',
          key: `noncod-${idx}`,
        })
        cols.push({
          expedition,
          type: 'cod',
          label: 'COD',
          key: `cod-${idx}`,
        })
      })
      return cols
    },
  },
  mounted() {
    this.getSubDistrict()
  },
  methods: {
    getSubDistrict() {
      const params = {
        city: this.$route.params.city,
        source: this.$route.query.product,
      }
      this.$http_new.get('/komship/api/v1/admin/coverage-area/district-data', { params })
        .then(res => {
          const { data } = res.data
          this.expeditions = data[0].coverage_data.map(item => item.shipping)
          this.listSubdistrictDefault = data.map(item => {
            const coverageMap = item.coverage_data.reduce((acc, cur) => {
              acc[cur.shipping] = cur.coverage_type
              return acc
            }, {})

            return {
              district_name: item.district_name,
              ...coverageMap,
            }
          })
          this.listSubdistrict = this.listSubdistrictDefault
          this.loadingData = false
        })
        .catch(err => {
          this.loadingData = false
          this.listSubdistrict = []
          this.$toast_error({ message: 'Tidak mendapatkan list kota' })
        })
    },
    searchArea: _.debounce(function search() {
      this.listSubdistrict = []
      this.loadingData = true
      if (this.search !== '') {
        const filter = this.listSubdistrictDefault.filter(district => district.district_name.toLowerCase().includes(this.search.toLowerCase()))
        this.listSubdistrict = filter
      } else {
        this.listSubdistrict = this.listSubdistrictDefault
      }
      this.loadingData = false
    }, 1000),
    getCoverageArea(item, expedition, value) {
      let result
      if (item[expedition] === 'open' || item[expedition] === 'unflat') {
        result = true
      } else if (item[expedition] === 'non cod' && value === 'non cod') {
        result = true
      } else if (item[expedition] === 'cod' && value === 'cod') {
        result = true
      } else {
        result = false
      }
      return result
    },
    downloadXcel(e) {
      window.open(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-area-page {
  border-radius: 8px;
  border: none;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.border-bottom-subtle {
  border-bottom: 1px solid #f1f1f4;
}

/* Back Button */
.btn-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
    color: #111827;
  }

  &:focus {
    outline: none;
  }
}

/* Search Bar */
.search-bar-wrapper {
  max-width: 420px;
  width: 100%;
}

.custom-search-input {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  height: 40px;
  transition: border-color 0.2s ease;

  &:focus-within {
    border-color: #f95031;
  }

  .input-group-text {
    padding: 0 0 0 12px;
  }

  input {
    height: 100%;
    font-size: 13px;
    color: #1f2937;

    &::placeholder {
      color: #9ca3af;
    }
  }
}

/* Info Legend Banner */
.info-legend-banner {
  background-color: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  padding: 10px 16px;
}

.custom-legend-checkbox {
  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #f95031;
    border-color: #f95031;
  }
}

/* Table Card Container */
.table-container-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
}

/* Custom Table */
.custom-detail-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;

  thead th {
    background-color: #f8f9fa !important;
    color: #1f2937 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border: none !important;
    border-bottom: 1px solid #e5e7eb !important;
    border-right: 1px solid #e5e7eb !important;
    padding: 10px 14px !important;
    white-space: nowrap;
    text-transform: inherit !important;
    vertical-align: middle !important;
  }

  tbody td {
    background-color: #ffffff;
    border: none !important;
    border-bottom: 1px solid #f3f4f6 !important;
    border-right: 1px solid #f3f4f6 !important;
    padding: 12px 16px !important;
    font-size: 13px !important;
    color: #1f2937;
    vertical-align: middle !important;
  }

  tbody tr {
    transition: background-color 0.15s ease;

    &:hover td {
      background-color: #fafbfc !important;
    }
  }

  tbody tr:last-child td {
    border-bottom: none !important;
  }

  /* Sticky Header & Column */
  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 15 !important;
    background-color: #f8f9fa !important;
  }

  .sticky-header-sub {
    position: sticky;
    top: 41px;
    z-index: 15 !important;
    background-color: #f8f9fa !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #1f2937 !important;
    padding: 8px 12px !important;
  }

  .sticky-col {
    position: sticky;
    left: 0;
    z-index: 10 !important;
    background-color: #ffffff !important;
    min-width: 220px;
    border-right: 1px solid #e5e7eb !important;
    box-shadow: 2px 0 6px -2px rgba(0, 0, 0, 0.06);
  }

  thead .sticky-col {
    top: 0;
    z-index: 25 !important;
    background-color: #f8f9fa !important;
  }

  tbody tr:hover .sticky-col {
    background-color: #fafbfc !important;
  }

  .district-header {
    font-weight: 500 !important;
    color: #1f2937 !important;
    text-align: left !important;
    padding: 12px 16px !important;
    min-width: 220px;
  }

  .district-cell {
    font-weight: 500;
    color: #1f2937;
  }

  .expedition-header {
    font-weight: 600 !important;
    color: #1f2937 !important;
    text-transform: uppercase;
    padding: 10px 14px !important;
    letter-spacing: 0.2px;
  }

  .type-header {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #1f2937 !important;
    min-width: 80px;
    padding: 8px 12px !important;
  }

  .checkbox-cell {
    min-width: 80px;
    text-align: center !important;
    vertical-align: middle !important;
  }
}

/* Custom Checkbox in Table */
::v-deep .custom-table-checkbox {
  position: relative !important;
  min-height: 18px;
  width: 18px;
  height: 18px;
  padding-left: 0 !important;
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  margin: 0 auto !important;
  vertical-align: middle;

  .custom-control-label {
    position: relative;
    width: 18px;
    height: 18px;
    margin: 0 !important;
    padding: 0 !important;
    cursor: default;

    &::before,
    &::after {
      left: 0 !important;
      top: 0 !important;
      width: 18px !important;
      height: 18px !important;
      border-radius: 4px;
    }

    &::before {
      border: 1px solid #d1d5db;
      background-color: #ffffff;
    }
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #f95031 !important;
    border-color: #f95031 !important;
  }
}
</style>
